import React from 'react';

const Bar1 = ({
    width,
    height,
    xScale,
    yScale,
    margin,
    data,
    xIndex,
    yIndex,
    format,
}) => {
    return (
        <svg
            width={width - 50}
            height={height}
            className="fill-current text-gray-700 dark:text-white">
            <text x={(width - margin.left - margin.right) / 2} y={margin.top * 0.3} key="xScale" className="xs:text-xs text-base font-bold">{`${xIndex} →`}</text>
            <text
                key="yScale"
                className="xs:text-xs text-base font-bold"
                transform={`translate(${margin.left * 0.3},${(height - margin.bottom - margin.top) / 2}) rotate(-90)`}>{yIndex}</text>

            {xScale.ticks().map((a, index) => (
                <g transform={`translate(${margin.left},0)`} key={`gTicks-${index}`} className="stroke-current text-gray-400 dark:text-gray-50">
                    <line
                        key={index}
                        x1={xScale(a)}
                        x2={xScale(a)}
                        y1={margin.top + 5}
                        y2={margin.top * 0.9}
                    />
                    <text
                        key={`xScaleText-$index}`}
                        textAnchor="middle"
                        x={xScale(a)}
                        y={(margin.top * 0.75)}
                        className="text-gray-700 dark:text-white text-xs">
                        {`${format(a)}`}
                    </text>
                </g>
            ))}
            {
                yScale.domain().map((a, index) => (
                    <g key={`gTicks-${index}`} className="stroke-current text-gray-400 dark:text-gray-50">
                        <line
                            key={`yScale-${index}`}
                            x1={margin.left + 5}
                            x2={margin.left * 0.9}
                            y1={yScale(a) + yScale.bandwidth() / 2}
                            y2={yScale(a) + yScale.bandwidth() / 2}
                        />
                        <text
                            key={`yScaleText-${index}`}
                            textAnchor="end"
                            dy="0.3em"
                            x={margin.left * 0.75}
                            y={yScale(a) + yScale.bandwidth() / 2}
                            className="text-gray-700 dark:text-white text-xs">
                            {a}
                        </text>
                    </g>
                ))
            }
            {
                data.map((a, index) => (
                    <g key={`group-${index}`} transform={`translate(0,0)`}>
                        <rect
                            key={index}
                            x={margin.left}
                            y={yScale(a.name)}
                            width={xScale(a.count)}
                            height={yScale.bandwidth()}>
                            <title key={`title-${index}`}>
                                {a.count}
                            </title>
                        </rect>
                        <text
                            key={`text2All-${index}`}
                            textAnchor="middle"
                            dx="0.8em"
                            className="text-white text-xs dark:text-gray-700"
                            x={xScale(a.count) + 20}
                            y={yScale(a.name) + yScale.bandwidth() / 2}
                        >
                            {`${format(a.count)}`}</text>
                    </g>
                ))
            }
        </svg>
    )
}

Bar1.defaultProps = {
    format: (a) => (a),
    width: 400,
    height: 400,
    xScale: (a) => (a),
    yScale: (a) => (a),
    margin: ({ top: 10, bottom: 10, right: 10, left: 10 }),
    data: [
        { name: "🍊", count: 21 },
        { name: "🍇", count: 13 },
        { name: "🍏", count: 8 },
        { name: "🍌", count: 5 },
        { name: "🍐", count: 3 },
        { name: "🍋", count: 2 },
        { name: "🍎", count: 1 },
        { name: "🍉", count: 1 }
    ],
    xIndex: "Fruit Counts",
    yIndex: "Fruits"
}

export default Bar1